<template>
  <v-container class="pa-0">
    <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
      <page-header-title :title="page_title"></page-header-title>

      <v-spacer></v-spacer>

      <action-button type="back" @click="$router.go(-1)" />

      <router-link
        :to="{ path: BACKEND_URL + '/classrooms/edit/' + classroom.id, props: { id: classroom.id } }"
        v-if="$can('classroom-edit')"
      >
        <action-button type="edit" />
      </router-link>

      <action-button type="delete" @click="del(classroom.id)" v-if="$can('classroom-delete')" />
    </v-app-bar>

    <v-form ref="form">
      <v-container grid-list-md>
        <v-card>
          <v-card-text class="pa-2">
            <v-layout row wrap>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="classroom.name"
                  v-model="classroom.name"
                  :label="$t('classrooms.name')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg6 md6 sm12 xs12>
                <v-text-field
                  name="classroom.address_id"
                  v-model="address.full_address"
                  :label="$t('classrooms.address_id')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-container>
    </v-form>
  </v-container>
</template>

<script>
export default {
  name: "ClassroomView",

  props: ["id"],

  data() {
    return {
      page_title: "",
      classroom: {},
      address: {}
    }
  },

  created() {
    axios
      .get(this.API_URL + "classroom/" + this.id)
      .then((res) => {
        this.classroom = res.data.data
        this.address = this.classroom.address

        this.page_title = this.$t("classrooms.view_classroom", { name: this.classroom.title })
      })
      .catch((err) => console.log(err))
  },

  methods: {
    del(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "classroom/" + id)
            .then((res) => {
              vm.$router.push(this.BACKEND_URL + "/classrooms")
              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    }
  }
}
</script>

<style scoped></style>
